import { supabase } from '../supabaseClient'

// Avisos de la plataforma para el Owner de una org (hoy: cambios de deportes).
// La RLS solo deja leerlos al Owner y al Platform Admin.

export const getAvisosPendientes = async (orgId) => {
  if (!orgId) return { data: [], error: null }
  const { data, error } = await supabase
    .from('org_avisos')
    .select('id, tipo, titulo, cuerpo, datos, created_at')
    .eq('org_id', orgId)
    .is('leido_at', null)
    .order('created_at', { ascending: false })
  return { data: data || [], error }
}

export const marcarAvisoLeido = async (avisoId) => {
  const { error } = await supabase.rpc('marcar_aviso_leido', { p_aviso_id: avisoId })
  return { error }
}
